// DS1.13
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './Loader.scss';
const Loader = ({ size, state = 'loading', className })=>{
    const pride = useFlag('pride24');
    const getImagePath = (state)=>({
            loading: pride ? 'loading/llama-pride22.gif' : 'loading/llama-med.gif',
            static: 'loading/llama-static.gif',
            disabled: 'loading/llama-disabled.png',
            popcorn: 'loading/llama-popcorn.gif',
            eating: 'loading/llama-eating.gif',
            eating_grass: 'loading/llama-eating-grass.gif?1',
            spitting: 'loading/llama-spitting.gif',
            skeleton: 'loading/llama-skeleton.gif',
            valentines: 'loading/llama-love.gif'
        })[state];
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], s[state], className)
    }, /*#__PURE__*/ React.createElement("img", {
        src: Url.staticCDNLink(getImagePath(state)),
        alt: "",
        className: s['llama']
    }));
};
Loader.displayName = 'Loader';
export default Loader;

//# sourceMappingURL=Loader.js.map